<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp
      ref="loadingcomp"
      v-bind:mesaj="loadingmesaj"
      v-model="loadingvmodel"
    ></loadingcomp>
    <v-card height="100%" color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar class="baslik" size="120px" dark color="info">
            <v-toolbar-title> Otel Kategori </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <v-btn
                :disabled="!sayfayetki.Save"
                slot="activator"
                @click.native="dialogAdd = true"
                flat
              >
                <span class="hidden-sm-and-down">
                  <span class="hidden-sm-and-down">{{ $t("Add") }}</span>
                </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Save">{{
                $t("Limited-Authorization")
              }}</span>
              <span v-if="sayfayetki.Save">{{ $t("Add") }}</span>
            </v-tooltip>
          </v-toolbar>
        </v-flex>

        <v-layout row="" wrap="">
          <v-flex pa-1 xs12 sm12 md12>
            <v-card>
              <v-data-table
                :headers="headers"
                :items="items"
                hide-actions
                class="elevation-1"
              >
                <template v-slot:items="props">
                  <td>{{ props.item.Isim }}</td>
                  <td class="text-xs-right">
                    <v-btn
                      flat
                      icon
                      color="red"
                      @click="openDeleteDialog(props.item)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-card>

    <v-layout row justify-center>
      <v-dialog v-model="dialogAdd" persistent max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Otel Kategori Ekle</span>
          </v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  label="Otel Kategori"
                  v-model="AddName"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              flat
              @click.native="dialogAdd = false"
              >{{ $t("cancel_button") }}</v-btn
            >
            <v-btn color="blue darken-1" flat @click="Add()">
              {{ $t("Add") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout row justify-center>
      <v-dialog v-model="dialogDelete" persistent max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Otel Kategori Sil</span>
          </v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <blockquote>
                  Bu kayıtı silmek istediğinize emin misiniz ?
                </blockquote>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              flat
              @click.native="dialogDelete = false"
              >{{ $t("cancel_button") }}</v-btn
            >
            <v-btn color="blue darken-1" flat @click="Delete()"> {{ $t('Delete') }} </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import loadingcomp from "@/components/app/customcomp/loadingcomp.vue";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tool from "../../coper/tools";
import helpers from "@/components/app/customcomp/helpers.js";

export default {
  data() {
    return {
      deleteId: 0,
      dialogDelete: false,
      AddName: null,
      dialogAdd: false,
      loadingvmodel: false,
      loadingmesaj: null,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      items: [],
      headers: [
        {
          text: "Otel Kategori",
          value: "Isim",
        },
        {
          text: "İşlem",
          align: "right",
        },
      ],
    };
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      this.getList();
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
  methods: {
    Delete() {
      this.loadingvmodel = true;
      let params = {
        Id: this.deleteId,
      };
      tool.http_post(this, "OtelKategoriDelete", params).then(
        (response) => {
          this.dialogDelete = false;
          if (response.body.Status == true) {
            this.getList();
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        (response) => {
          this.loadingvmodel = false;
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
          this.dialogDelete = false;
        }
      );
    },
    openDeleteDialog(id) {
      this.dialogDelete = true;
      this.deleteId = id.Id;
    },
    Add() {
      this.loadingvmodel = true;
      let params = {
        Isim: this.AddName,
      };
      tool.http_post(this, "OtelKategoriInsert", params).then(
        (response) => {
          this.dialogAdd = false;
          if (response.body.Status == true) {
            this.getList();
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        (response) => {
          this.loadingvmodel = false;
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
          this.dialogAdd = false;
        }
      );
    },
    getList() {
      this.loadingvmodel = true;

      tool.http_post(this, "OtelKategoriList", {}).then(
        (response) => {
          this.loadingvmodel = false;

          if (response.body.Status == true) {
            this.items = response.body.data;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.loadingvmodel = false;
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
  },
  components: {
    loadingcomp,
    yetkidialog,
  },
};
</script>

<style>
</style>